import { RoleGuard } from "app/guards";
import { Navigate, Route, Routes } from "react-router-dom";
import { EstablecimientosRoutes } from "./establecimientos-routes";
import { TelefonosRoutes } from "./telefonos-routes";
import { CelularesRoutes } from "./celulares-routes";
import { CorreosElectronicosRoutes } from "./correos-electronicos-routes";
import { PaginasWebRoutes } from "./paginas-web-routes";
import { EncargadosRoutes } from "./encargados-routes";
import { ActividadesEconomicasRoutes } from "./actividades-economicas-routes";
import { ImportacionesRoutes } from "./importaciones-routes";
import { ExportacionesRoutes } from "./exportaciones-routes";
import { ArchivosRoutes } from "./archivos-routes";
import { InformacionGeneralRoutes } from "./informacion-general-routes";
import { GeneralLayout } from "./general-layout";
import { FormatosRoutes } from "./formatos-routes";

export function GeneralRoutes() {
  return (
    <RoleGuard roles={["empresa:informacion-general"]}>
      <Routes>
        <Route path="/" element={<GeneralLayout />}>
          <Route
            index
            element={<Navigate to="informacion-general" replace />}
          />

          <Route
            path="informacion-general/*"
            element={<InformacionGeneralRoutes />}
          />

          <Route
            path="establecimientos/*"
            element={<EstablecimientosRoutes />}
          />

          <Route path="telefonos/*" element={<TelefonosRoutes />} />

          <Route path="celulares/*" element={<CelularesRoutes />} />

          <Route
            path="correos-electronicos/*"
            element={<CorreosElectronicosRoutes />}
          />

          <Route path="paginas-web/*" element={<PaginasWebRoutes />} />

          <Route path="encargados/*" element={<EncargadosRoutes />} />

          <Route
            path="actividades-economicas/*"
            element={<ActividadesEconomicasRoutes />}
          />

          <Route path="importaciones/*" element={<ImportacionesRoutes />} />

          <Route path="exportaciones/*" element={<ExportacionesRoutes />} />

          {/* <Route path="archivos/*" element={<ArchivosRoutes />} /> */}

          {/* <Route path="formatos/*" element={<FormatosRoutes />} /> */}

          <Route path="*" element="InformacionGeneralRoutes: Page Not Found" />
        </Route>
      </Routes>
    </RoleGuard>
  );
}
